// extracted by mini-css-extract-plugin
export default {"acceptBtn":"DataUserBill_acceptBtn__9DnhW","btnsContainer":"DataUserBill_btnsContainer__84zUP","successMessage":"DataUserBill_successMessage__t6O6W"};